import * as React from "react";
const SvgAccess = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.729 2.42a.75.75 0 0 1 .972-.423l3.473 1.37a.75.75 0 0 1 .45.504l1.3 4.856 1.45-.388-.842-3.14a.75.75 0 0 1 .53-.918l4.83-1.294a.75.75 0 0 1 .919.53l.841 3.14 1.208-.324a.75.75 0 0 1 .918.53l2.394 8.935 1.208-.323a.75.75 0 1 1 .388 1.449l-1.932.517h-.003l-7.1 1.903a2.751 2.751 0 1 1-4.16-2.401L6.67 9.84l-.003-.01-1.395-5.206-3.121-1.232a.75.75 0 0 1-.422-.973Zm8.293 14.135a2.755 2.755 0 0 1 2.323 1.34l6.378-1.709-2.2-8.21-8.21 2.2 1.71 6.379Zm.153-11.02.647 2.416 3.381-.906-.647-2.415-3.38.906Zm-1.4 14.093a1.25 1.25 0 1 1 2.415-.647 1.25 1.25 0 0 1-2.415.647Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgAccess;
